// RawMaterialCategory.jsx - Replace the ColumnMappingConfig with CategoryColumnConfig
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { fetchAllRawMaterialCategoryAction } from '../../../../utils/redux/rawMaterialCategory/rawMaterialCategoryActions';
import { IoIosArrowDown } from "react-icons/io";
import { fetchCategoryTableColumns } from '../../../../utils/api-service/get-services'; // Change this
import { updateCategoryDisplayColumns } from '../../../../utils/api-service/put-services';
import CategoryColumnConfig from './CategoryColumnConfig/CategoryColumnConfig';

const RawMaterialCategory = () => {
    const dispatch = useDispatch();
    const { rawMaterialCategories, isLoading } = useSelector(state => state.rawMaterialCategory);
    const [openRow, setOpenRow] = useState(null);
    const [showColumnMapping, setShowColumnMapping] = useState(false);
    const [selectedCategoryForMapping, setSelectedCategoryForMapping] = useState(null);
    const [categoryConfig, setCategoryConfig] = useState(null);

    useEffect(() => {
        if (!rawMaterialCategories || !rawMaterialCategories.length)
            dispatch(fetchAllRawMaterialCategoryAction());
    }, [dispatch]);

    const openColumnMapping = async (category) => {
        console.log('Opening column mapping for category:', category);
        setSelectedCategoryForMapping(category);
        try {
            // Use the correct API endpoint
            const response = await fetchCategoryTableColumns(category._id);
            console.log('Fetch category table columns response:', response);

            if (response?.success) {
                setCategoryConfig(response.data);
                setShowColumnMapping(true);
            } else {
                console.error('Failed to fetch config:', response);
                alert('Failed to load category configuration. Please try again.');
            }
        } catch (error) {
            console.error("Error loading category mappings:", error);
            alert('Error loading category configuration. Check console for details.');
        }
    };

    const handleSaveMappings = async (config) => {
        console.log('Saving config for category:', selectedCategoryForMapping?._id, config);
        try {
            // The API expects displayColumns, but we're saving tableColumns
            const payload = {
                displayColumns: config.tableColumns, // Map tableColumns to displayColumns for API
                displaySettings: config.displaySettings
            };

            const response = await updateCategoryDisplayColumns(selectedCategoryForMapping._id, payload);
            console.log('Save response:', response);

            if (response?.success) {
                alert("Column configuration saved successfully!");
                setShowColumnMapping(false);
                dispatch(fetchAllRawMaterialCategoryAction());
            } else {
                alert(response?.message || "Error saving configuration");
            }
        } catch (error) {
            console.error("Error saving mappings:", error);
            alert("Error saving configuration. Check console for details.");
        }
    };

    return (
        <>
            <div className="d-flex flex-column align-items-center">
                <div className="d-flex my-4 w-100 justify-content-between">
                    <h3>Raw Material Category</h3>
                </div>

                <div className="w-100">
                    <table className="table table-sm align-middle mt-3">
                        <thead className="table-secondary">
                            <tr>
                                <th className="p-3">Category Name</th>
                                <th className="p-3">Type Name</th>
                                <th className="p-3">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rawMaterialCategories?.length ? (
                                rawMaterialCategories.map((item, index) => (
                                    <React.Fragment key={item._id}>
                                        <tr
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setOpenRow(openRow === index ? null : index)}
                                        >
                                            <td className="p-3">
                                                <div className="d-flex align-items-center">
                                                    <span className="me-2 transition-rotate" style={{
                                                        display: "inline-block",
                                                        transform: openRow === index ? "rotate(180deg)" : "rotate(0deg)",
                                                        transition: "transform 0.2s ease"
                                                    }}>
                                                        <IoIosArrowDown />
                                                    </span>
                                                    {item.name}
                                                </div>
                                            </td>
                                            <td className="p-3">{item.type}</td>
                                            <td className="p-3">
                                                <button
                                                    className="btn btn-sm btn-info me-2"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        openColumnMapping(item);
                                                    }}
                                                >
                                                    Configure Columns
                                                </button>
                                                <button
                                                    className="btn btn-sm text-danger"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    Remove
                                                </button>
                                            </td>
                                        </tr>
                                        {openRow === index && (
                                            <tr>
                                                <td colSpan="3" className="bg-light">
                                                    {item.propertyDefinitions?.length ? (
                                                        <table className="table table-sm mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <th>Label</th>
                                                                    <th>Type</th>
                                                                    <th>Required</th>
                                                                    <th>Unit</th>
                                                                    <th>Options</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {item.propertyDefinitions.map((prop, i) => (
                                                                    <tr key={i}>
                                                                        <td>{prop.name}</td>
                                                                        <td>{prop.label}</td>
                                                                        <td>{prop.type}</td>
                                                                        <td>{prop.required ? "Yes" : "No"}</td>
                                                                        <td>{prop.unit || "-"}</td>
                                                                        <td>{prop.options?.length ? prop.options.map(o => o.label).join(", ") : "-"}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    ) : (
                                                        <div className="text-muted p-3">No properties defined</div>
                                                    )}
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center text-muted">
                                        {isLoading ? "Loading..." : "No Categories found"}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {showColumnMapping && categoryConfig && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Configure Table Columns for {selectedCategoryForMapping?.name}
                                </h5>
                                <button type="button" className="btn-close" onClick={() => setShowColumnMapping(false)}></button>
                            </div>
                            <div className="modal-body">
                                <CategoryColumnConfig
                                    category={selectedCategoryForMapping}
                                    tableColumns={categoryConfig.tableColumns || []}
                                    displaySettings={categoryConfig.displaySettings}
                                    onSave={handleSaveMappings}
                                    onClose={() => setShowColumnMapping(false)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
};

export default RawMaterialCategory;